<script>

</script>

<style>

.training {
    border-top: 0.2rem solid rgba(0,175,170,1);
    font-family: bebas-neue-by-fontfabric,sans-serif;
	font-weight: 700;
	font-style: normal;
    padding: 2rem 1rem 2rem 1rem;
    width: 100%;
}

.training h1 {
    font-size: 3 rem;
    text-align: center;
}

.trainingGreen {
    color: rgba(0,175,170,0.5);
}
</style>

<div id="training" class="training">
    <h1>Training Section</h1>
    <h1 class="trainingGreen">Under Construction</h1>
</div>
